<cc-casino-page-container *ngIf="isLobbyLoaded" [lobbyType]="'instantCasino'" [categoryRoute]="'home'"> </cc-casino-page-container>
